import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import cns from 'classnames';
import { v4 as uuid } from 'uuid';
import { Field } from 'redux-form';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import ImageUpload from '../../../../../shared/components/formComponents/inputs/ImageUpload';
import VerbHeading from '../../../../../shared/components/VerbHeading';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import { ASSET_METADATA_LOOKUP, ASSET_METADATA_CATEGORIES } from '../../../../../shared/Constants';

const metadataArray = Object.values(ASSET_METADATA_LOOKUP).map((metadataItem) => {
    const newLabel = `${metadataItem.label} - ${ASSET_METADATA_CATEGORIES[metadataItem.categoryId].label}`;
    metadataItem.label = newLabel;
    return metadataItem;
});

export class ChooseOption extends Component {
    static propTypes = {
        fields: PropTypes.any,
        contentValues: PropTypes.shape({
            displayType: PropTypes.string,
            options: PropTypes.array
        }),
        isQuizType: PropTypes.bool,
        disabled: PropTypes.bool,
        metadataActive: PropTypes.bool
    };

    pushOtherInputField = () => {
        const id = uuid();

        const fieldObject = {
            image: '',
            label: 'Other ',
            choice: id,
            isOther: true
        };
        this.props.fields.push(fieldObject);
    };

    addField = (hasOther) => {
        const { isQuizType } = this.props;
        let fieldObject;
        const id = uuid();

        if (isQuizType) {
            fieldObject = {
                id,
                label: '',
                isCorrect: false
            };
        } else {
            fieldObject = {
                label: '',
                image: '',
                choice: id
            };
        }
        if (hasOther) {
            const otherField = this.props.fields.pop();
            this.props.fields.push(fieldObject);
            this.props.fields.push(otherField);
        } else {
            this.props.fields.push(fieldObject);
        }
    };

    removeField = (i) => {
        this.props.fields.remove(i);
    };

    moveUp = (i) => {
        if (i) {
            this.props.fields.swap(i, i - 1);
        }
    };

    moveDown = (i) => {
        if (i < this.props.fields.length - 1) {
            this.props.fields.swap(i, i + 1);
        }
    };

    render() {
        const {
            fields,
            disabled,
            metadataActive = false,
            contentValues: { displayType = '', options = {} }
        } = this.props;

        const hasOther = options && options.length && options[options.length - 1].isOther;
        const otherOptionButton = !hasOther ? (
            <VerbButton className={'col-4 ms-auto'} fontAwesomeIcon={'fa-plus'} onClick={this.pushOtherInputField}>
                Add Other Option
            </VerbButton>
        ) : (
            <VerbButton
                className={'col-4 ms-auto'}
                fontAwesomeIcon={'fa-minus'}
                onClick={() => this.removeField(options.length - 1)}
                buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
            >
                Remove Other Option
            </VerbButton>
        );

        const fieldsArray = fields.map((name, idx) => {
            const key = options[idx].choice || options[idx].id;
            const { isOther } = options[idx];
            return (
                <div key={key} className={'chooseSectionItem-optionInput col-12 row'}>
                    {displayType === 'image' ? (
                        <Field
                            name={`${name}.image`}
                            className={cns('col-7', { hidden: isOther })}
                            cropProp={{ width: 150, height: 150 }}
                            component={ImageUpload}
                            disabled={disabled}
                        />
                    ) : null}
                    <div className={displayType === 'image' ? 'col-md-5 row' : 'col-12 row'}>
                        {!disabled && !isOther ? (
                            <div className={'col-md-offset-6 col-md-6 optionButtons ms-auto'}>
                                <Button onClick={() => this.moveUp(idx)} className={'col-4 chooseSectionItem-swapUp'}>
                                    <i className={'fa fa-angle-up'} />
                                </Button>
                                <Button
                                    onClick={() => this.moveDown(idx)}
                                    className={'col-4 chooseSectionItem-swapDown'}
                                >
                                    <i className={'fa fa-angle-down'} />
                                </Button>
                                <Button
                                    onClick={() => this.removeField(idx)}
                                    className={'col-4 chooseSectionItem-delete'}
                                >
                                    <i className={'fa fa-trash'} />
                                </Button>
                            </div>
                        ) : null}
                        {!isOther ? (
                            <Field
                                name={`${name}.label`}
                                placeholder={'Enter option text.'}
                                className={'col-12'}
                                component={VerbRichTextEditor}
                                rows={2}
                                props={{ disabled, containerClass: 'col-12' }}
                            />
                        ) : (
                            <>
                                <VerbHeading
                                    className={cns({ hidden: !['radio', 'box'].includes(displayType) })}
                                    defaultMessage={'"Other" option included in list'}
                                    hNumber={4}
                                />
                                <Field
                                    name={`${name}.disableOtherTextBox`}
                                    label={'Disable "Other" Text Box?'}
                                    className={'col-4 disable-other-text-box'}
                                    component={BasicToggle}
                                    id={'disable-other-text-box'}
                                />
                            </>
                        )}
                        {metadataActive ? (
                            <Field
                                name={`${name}.metadataTag`}
                                className={'col-12'}
                                component={BasicSelect}
                                label={'Metadata'}
                                options={metadataArray}
                                labelKey={'label'}
                                valueKey={'id'}
                            />
                        ) : null}
                    </div>
                </div>
            );
        });
        return (
            <div className={'chooseSectionItem-optionFields col-12'}>
                <div className={'row'}>{fieldsArray}</div>
                {!disabled ? (
                    <div>
                        <div className={'row'}>
                            <VerbButton
                                className={'col-4 choose-option-add-field'}
                                fontAwesomeIcon={'fa-plus'}
                                onClick={() => this.addField(hasOther)}
                            >
                                Add New Option
                            </VerbButton>
                            {displayType === 'radio' || displayType === 'box' ? otherOptionButton : null}
                        </div>
                    </div>
                ) : null}
                <br />
            </div>
        );
    }
}

export default ChooseOption;
